<template>
  <div class="specs">
    <div class="page">
      <div class="title">
        <h1>Especificações</h1>
        <hr />
        <!-- <div class="custom-select">
          <select class="selectVersao" disabled>
            <option selected value="versao1">Versão 2.34</option>
          </select>
        </div> -->
      </div>

      <div class="corpoEspeficacoes">
        <h4 class="mt-3">Introdução</h4>
        <p class="mb-1" style="white-space: pre-wrap">{{ dados.introducao }}</p>
        <h4 class="mt-2">Objetivo</h4>
        <p class="mb-1" style="white-space: pre-wrap">{{ dados.objetivo }}</p>
        <h4 class="mt-2">Premissas</h4>
        <p class="mb-1" style="white-space: pre-wrap">{{ dados.premissas }}</p>

        <h4 class="mt-1">Url's base</h4>

        <table class="quadro-table mt-2 mb-1">
          <colgroup>
            <col style="width: 180px">
            <col>
          </colgroup>
          <tbody>
            <tr>
              <td class="text-card quadro-label"><strong>URL Aceite W:</strong></td>
              <td class="quadro-value">{{ dados.urlAceiteW }}</td>
            </tr>
            <tr>
              <td class="text-card quadro-label"><strong>URL Aceite Y:</strong></td>
              <td class="quadro-value">{{ dados.urlAceiteY }}</td>
            </tr>
            <tr>
              <td class="text-card quadro-label"><strong>URL Produção:</strong></td>
              <td class="quadro-value">{{ dados.urlProducao }}</td>
            </tr>
          </tbody>
        </table>


        <h4 v-if="(dados.listaAutenticacaoAceite  && dados.listaAutenticacaoAceite.length > 0) || (dados.listaAutenticacaoProducao  && dados.listaAutenticacaoProducao.length > 0)" class="mt-1">Autenticação </h4>
        <div v-if="dados.listaAutenticacaoAceite && dados.listaAutenticacaoAceite.length">
          <span class="text-card titulo-bloco">Aceite W e Y</span>

          <table class="quadro-table mt-2">
            <colgroup>
              <col style="width: 180px">
              <col>
            </colgroup>
            <tbody>
              <tr v-for="(item, index) in dados.listaAutenticacaoAceite" :key="'aceite-' + index">
                <td class="text-card quadro-label"><strong>{{ item.codigo }}:</strong></td>
                <td class="quadro-value">{{ item.descricao }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="dados.listaAutenticacaoProducao && dados.listaAutenticacaoProducao.length">
          <span class="text-card titulo-bloco">Produção</span>

          <table class="quadro-table mt-2 ">
            <colgroup>
              <col style="width: 180px">
              <col>
            </colgroup>
            <tbody >
              <tr v-for="(item, index) in dados.listaAutenticacaoProducao" :key="'producao-' + index">
                <td class="text-card quadro-label"><strong>{{ item.codigo }}:</strong></td>
                <td class="quadro-value">{{ item.descricao }}</td>
              </tr>
            </tbody>
          </table>
        </div>


        
        <!-- Gestão Parceiros == G -->
        <div v-if="dados.apiManager === 'G'">
          <div class="title mt-5 mb-1">
            <h1>
              API Gestão
              <span>POST</span>
            </h1>
          </div>

          <table class="quadro-table mt-1 mb-2">
            <colgroup>
              <col style="width: 180px">
              <col>
            </colgroup>
            <tbody>
              <tr>
                <td class="text-card quadro-label"><strong>URL Token Aceite W:</strong></td>
                <td class="quadro-value">https://servicos-aceitew.tokiomarine.com.br/wscorretor/rest/Corretor/login</td>
              </tr>
              <tr>
                <td class="text-card quadro-label"><strong>URL Token Aceite Y:</strong></td>
                <td class="quadro-value">https://servicos-aceitey.tokiomarine.com.br/wscorretor/rest/Corretor/login</td>
              </tr>
              <tr>
                <td class="text-card quadro-label"><strong>URL Token Produção:</strong></td>
                <td class="quadro-value">https://servicos.tokiomarine.com.br/wscorretor/rest/Corretor/login</td>
              </tr>
            </tbody>
          </table>


          <h4 class="mt-1">Parâmetros:</h4>

          <table class="quadro-table mt-1 mb-2">
            <colgroup>
              <col style="width: 180px">
              <col>
            </colgroup>
            <tbody>
              <tr>
                <td class="text-card quadro-label"><strong>service_key:</strong></td>
                <td class="quadro-value">xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx</td>
              </tr>
              <tr>
                <td class="text-card quadro-label"><strong>user:</strong></td>
                <td class="quadro-value">yyyyyyyy-yyyy-yyyy-yyyy-yyyyyyyyyyyy</td>
              </tr>
              <tr>
                <td class="text-card quadro-label"><strong>password:</strong></td>
                <td class="quadro-value">zzzzzzzz-zzzz-zzzz-zzzz-zzzzzzzzzzzz</td>
              </tr>
            </tbody>
          </table>

          <div>
            <h4 class="mt-1">Exemplo Request</h4>
          </div>
          <div class="code">
            <div>curl --location 'https://servicos-aceitew.tokiomarine.com.br/wscorretor/rest/Corretor/login' \</div>
            <div>--header 'service_key: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' \</div>
            <div>--header 'Content-Type: application/json' \</div>
            <div>--data '{</div>
            <div>    "user": "yyyyyyyy-yyyy-yyyy-yyyy-yyyyyyyyyyyy",</div>
            <div>    "password": "zzzzzzzz-zzzz-zzzz-zzzz-zzzzzzzzzzzz"</div>
            <div>}'</div>                
          </div>
          <div>
            <h4 class="mt-2">Exemplo Response</h4>
          </div>
          <div class="code">
            <div>{</div>
            <div class="mt-1 json-indent" >
              <div>"data": {</div>
                <div class="json-indent2">"auth_token": "XXXXXXXXXX.XXXXXXXXXXXXXXXXXXXX.XXXXXXXXXXXXXXXXXXXX.XXXXXXXXXX"</div>
              <div class="json-indent">}</div>
            </div>
            <div>}</div>
          </div>
        </div>
        
        <!-- Api Manager == A -->
        <div v-if="dados.apiManager === 'A'">
          <div class="title mt-4 mb-1">
            <h1>
              API Manager
              <span>POST</span>
            </h1>
          </div>
          <div class="parteMeioCards mb-1">
            <span>https://apim.tokiomarine.com.br/oauth2/v2.0/token</span>
          </div>
          
          <div>
            <h4 class="mt-1">Parametros (FORM)</h4>
          </div>
          <div class="parteMeioCards mt-3 mb-2">
            <div class="cardCorpo1 cardCorpoMenor1">
              <span class="text-card">client_id:</span>
              <span class="text-card">client_secret:</span>
              <span class="text-card">scope:</span>
              <span class="text-card">grant_type:</span>
            </div>
            <div class="cardCorpo2">
              <span class="text-card2">xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx</span>
              <span class="text-card2">yyyyyyyy-yyyy-yyyy-yyyy-yyyyyyyyyyyy</span>
              <span class="text-card2">api://zzzzzzzz-zzzz-zzzz-zzzz-zzzzzzzzzzzz/.default</span>
              <span class="text-card2">client_credentials</span>
            </div>
          </div>

          <div>
            <h4 class="mt-1">Exemplo Request</h4>
          </div>
          <div class="code mt-3 mb-2">
            <div>curl --location --request POST 'https://apim.tokiomarine.com.br/oauth2/v2.0/token' \</div>
            <div class="mt-1 json-indent" >
                <div>--header 'Content-Type: application/x-www-form-urlencoded' \</div>
                <div>--header 'Cookie: fpc=AvZys3X-fZtIn5UhYIR3lvucBSKTAQAAANKKl94OAAAA; x-ms-gateway-slice=estsfd; stsservicecookie=estsfd' \</div>
                <div>--data-urlencode 'client_id=xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' \</div>
                <div>--data-urlencode 'client_secret=yyyyyyyy-yyyy-yyyy-yyyy-yyyyyyyyyyyy' \</div>
                <div>--data-urlencode 'scope=api://zzzzzzzz-zzzz-zzzz-zzzz-zzzzzzzzzzzz/.default' \</div>
                <div>--data-urlencode 'grant_type=client_credentials'</div>                
            </div>
          </div>
          
          <div>
            <h4 class="mt-1">Exemplo Response</h4>
          </div>
          <div class="code mt-3">
            <div>{</div>
            <div class="mt-1 json-indent" >
              <div>"token_type": "Bearer",</div>
              <div>"expire_in": 3600,</div>
              <div>"ext_expires_in": 3600,</div>
              <div>"access_token": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa"</div>
            </div>
            <div>}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: "Especificacoes",
  props: {
    dadosApiCatalogo: {
      type: Object,
      default: () => {},
    },
    grupo: String,
    nome: String,
    segmentacao: String
  },
  data() {
    return {
      dados: {},
      subMenuAtual: null,
      subMenuAberto: false,
    };
  },
  // computed() { 

  methods: {
    async carregarDados() {

      try {
        this.dados = this.dadosApiCatalogo;

      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    },
  },
  watch: {
    dadosApiCatalogo: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.dados = newValue;
        } else {
          console.warn(
            "Novos dados recebidos em dadosApiCatalogo são undefined ou vazios."
          );
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.dados = this.dadosApiCatalogo;
  },
  mounted() {
    this.carregarDados();
    setTimeout(() => {
      document.querySelector(".page").classList.add("show");
    }, 500);
  },
};
</script>

<style scoped>
.cardCorpoMenor1 {
  width: 21% !important ;
}

.cardCorpoApiGestao {
  width: 35% !important;
}

.cardCorpo2 {
  width: 80% !important;
}

.cardCorpoMenor2 {
  width: 40% !important ;
}

.json-indent{
  margin-left: 12px !important;
}

.json-indent2{
  margin-left: 22px !important;
}

.container-autenticacao {
  display: flex; 
}

.container-autenticacao-aceite,
.container-autenticacao-prod {
  flex: 1;
  padding: 15px;
}

/* Títulos */
.container-autenticacao-aceite .text-card,
.container-autenticacao-prod .text-card {
  font-weight: bold;
  font-size: 1rem;
  display: block;
  margin-bottom: 10px;
}

.cardCorpo1 {
  max-width: 30% !important;
}

.cardCorpo1,
.cardCorpo2 {
  flex: 1;
}

.cardCorpo1 span,
.cardCorpo2 span {
  display: block;

}

.container-descricao{

    font-size: 10px !important;
  
}

.quadro-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #d9d9d9;
}

.quadro-table td {
  padding: 5px 12px;
  vertical-align: top;
}

.quadro-label {
  background: #ffffff;
  font-weight: 500;
  white-space: nowrap;
  border-right: 1px solid #d9d9d9;
  border-top: 1px solid #ffffff;
  border-left: 1px solid #d9d9d9;
  padding-left: 3% !important;
  border-bottom: none !important;
}

.quadro-value {
  background: #f3f3f3;
  word-break: break-word;
  border: 1px solid #f3f3f3;
}

.quadro-table tr:first-child .quadro-label {
  border-top: 1px solid #d9d9d9;
}

.titulo-bloco {
  display: block;
  margin-top: 20px;
  margin-bottom: 8px;
}



</style>
